import React from 'react';

import { OrderStatusTypeColor, OrderStatusTypeText, Results } from 'src/types/IOrder';

import { TRBody, Dot } from './styles';

interface IProps {
  item: Results;
}

const GridItem = ({ item }: IProps) => {
  return (
    <TRBody>
      <td className='nowrap'>{item.fullName}</td>
      <td>{item.gpId}</td>
      <td>
        {item.hiringDate
          ? new Date(item?.hiringDate).toLocaleDateString('pt-BR', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            })
          : ''}
      </td>
      <td>{item.level}</td>
      <td>{item.position}</td>
      <td>{item.name}</td>
      <td>
        {item.year}/{item.yearModel}
      </td>
      <td>{item.licensePlate}</td>
      <td>{item.orderId}</td>
      <td>
        {item.createdDate
          ? new Date(item?.createdDate).toLocaleDateString('pt-BR', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            })
          : ''}
      </td>

      <td className='nowrap'>
        <Dot color={OrderStatusTypeColor[item.status]} />
        {OrderStatusTypeText[item.status]}
      </td>
    </TRBody>
  );
};

export default GridItem;
